// Default filter values for hires page
export const defaultFilters = {
  keyword: '',
  importerIds: [],
  companyName: [],
  companyDomain: [],
  dateFrom: '',
  teamInvolvement: [],
  reviewStatus: '',
  hireDate: null,
  sources: [],
  firstSeen: 'any',
  sortBy: 'date_from',
  sortDirection: 'desc',
};

// Check if filters are at their default state
export const isDefaultFilters = (filters) => {
  const keys = Object.keys(defaultFilters);
  return keys.every((key) => {
    const defaultValue = defaultFilters[key];
    const currentValue = filters[key];

    // Handle arrays
    if (Array.isArray(defaultValue)) {
      return !currentValue || (Array.isArray(currentValue) && currentValue.length === 0);
    }

    // Handle null/undefined
    if (defaultValue === null || defaultValue === undefined) {
      return currentValue === null || currentValue === undefined || currentValue === '';
    }

    // Handle empty strings
    if (defaultValue === '') {
      return !currentValue || currentValue === '';
    }

    // Handle 'any' as default
    if (defaultValue === 'any') {
      return !currentValue || currentValue === 'any' || currentValue === '';
    }

    return currentValue === defaultValue;
  });
};
